import React from 'react';
import './Help.css';

const Help = () => {
  return (
    <div className="help-container">
      <h2>Help & Support</h2>
      <p>
        Find answers to frequently asked questions below. If you need further assistance, please contact our support team.
      </p>
      <hr />
      <h5>Frequently Asked Questions</h5>
      <h6>How do I reset my password?</h6>
      <p>
        You can reset your password by clicking on the "Forgot Password?" link on the login page. You will receive an email with instructions on how to reset your password.
      </p>
      <h6>How do I update my profile information?</h6>
      <p>
        You can update your profile information by navigating to the "Profile" page from the sidebar. You can edit your name, mobile number, and profile picture.
      </p>
      <h6>How do I view my order history?</h6>
      <p>
        You can view your order history by navigating to the "My Orders" page from the customer dashboard.
      </p>
      <h6>How do I upload a prescription?</h6>
      <p>
        You can upload a prescription by navigating to the "My Prescriptions" page from the customer dashboard and clicking on the "Upload Prescription" button.
      </p>
      <h6>How do I view my payment history?</h6>
      <p>
        You can view your payment history by navigating to the "My Payments" page from the customer dashboard.
      </p>
      <hr />
      <h5>Contact Us</h5>
      <p>
        If you have any questions or need further assistance, please contact our support team at <a href="mailto:support@example.com">support@example.com</a>.
      </p>
    </div>
  );
};

export default Help;